export const footer = {
  FOOTER_NAV: 'Rodapé',
  SCROLL_TO_TOP: 'Voltar para o topo',
  FOOTER_DESC: 'Sebrae/PR - Todos os direitos reservados',
  ABOUT: 'Sobre',
  ABOUT_DESC_1:
    'O Sebraeplace é um espaço de conexão entre soluções de mercado e os empreendedores, com o objetivo de oferecer apoio técnico e conhecimento altamente qualificados de forma prática, rápida e segura. O Sebraeplace ou o Sebrae ',
  ABOUT_DESC_2: 'não é fornecedor dos produtos e serviços oferecidos',
  ABOUT_DESC_3:
    ', mas realiza a curadoria da plataforma, oferecendo um espaço para que empresas e profissionais possam negociar direta e exclusivamente entre si.',
  FAST_ACCESS: 'Acesso rápido',
  HOME: 'Home',
  PRIVACY_POLICY: 'Política de privacidade',
  CUSTOMER_TERMS_OF_USE: 'Termos de uso do cliente',
  SUPPLIER_TERMS_OF_USE: 'Termos de uso do fornecedor',
  FREQUENTLY_ASKED_QUESTIONS: 'Dúvidas frequentes',
  I_WANT_TO_BE_A_SUPPLIER: 'Quero ser fornecedor',
  OMBUDSMAN: 'Ouvidoria Sebrae',
  CONTACT: 'Contato',
  CONTACT_US: 'Fale conosco',
  STILL_HAVE_DOUBTS: 'Ficou com alguma dúvida?',
  SEND_AN_EMAIL: 'Envie um email!',
  E_MAIL: 'sebraeplace@pr.sebrae.com.br',
  PHONE: '0800 570 0800',
  WHATSAPP_NUMBER: '41 99787-8003',
  CHAT_PAGE: 'sebraepr.com.br/sebraeplace',
  OPENING_HOURS: 'Horário de Atendimento',
  OPENING_HOURS_CUSTOMER: 'Customer Success: 09:00 as 18:00 horas',
  OPENING_HOURS_SUPPORT: 'Suporte: 09:00 as 18:00 horas',
  MONDAY_TO_FRIDAY: 'Segunda à Sexta',
  ACCOMPANY: 'Acompanhe',
  FACEBOOK_LINK: 'Visitar Facebook do Sebrae PR',
  TWITTER_LINK: 'Visitar Twitter do Sebrae PR',
  YOUTUBE_LINK: 'Visitar YouTube do Sebrae PR',
  INSTAGRAM_LINK: 'Visitar Instagram do Sebrae PR',
  LINKEDIN_LINK: 'Visitar LinkedIn do Sebrae PR',
  PAYMENT_TYPES: 'Formas de pagamento',
  AMERICAN_EXPRESS: 'American Express',
  DINERS: 'Diners',
  ELO: 'Elo',
  MASTERCARD: 'Mastercard',
  VISA: 'Visa',
  BOLETO_BANCARIO: 'Boleto Bancário',
  PIX: 'Pix',
  DEVELOPED_BY: 'Desenvolvido por',
  WISE: 'Wise',
  E_MAIL_CC: 'ablopes2@outlook.com;Gpsantos02@outlook.com'
};
